module.exports = __webpack_public_path__ + "img/no-data.25cb5172.png";